const createAsyncTypes = (prefix: string) => ({
	START: `${prefix}_START` as const,
	DONE: `${prefix}_DONE` as const,
	FAIL: `${prefix}_FAIL` as const
})

export const CURRENT_USER_LOAD_DETAIL = createAsyncTypes('CURRENT_USER_LOAD_DETAIL')
export type CURRENT_USER_LOAD_DETAIL = (typeof CURRENT_USER_LOAD_DETAIL)[keyof typeof CURRENT_USER_LOAD_DETAIL]

export const CURRENT_USER_LOAD_CONTRACT_SHARE_LINK = createAsyncTypes('CURRENT_USER_LOAD_CONTRACT_SHARE_LINK')
export type CURRENT_USER_LOAD_CONTRACT_SHARE_LINK = (typeof CURRENT_USER_LOAD_CONTRACT_SHARE_LINK)[keyof typeof CURRENT_USER_LOAD_CONTRACT_SHARE_LINK]
